__turbopack_context__.v({
  "badge": "aOBmSW_badge",
  "root": "aOBmSW_root",
});
